import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
/*================================

ContentsList

================================*/
export class ContentsList {
    constructor(pamph) {
        this.pamph = pamph;
        //目次リスト
        this.list = [
            {
                page: 0, dir:'right', small:false, title: '覆盖'
            },
            {
                page: 1, dir:'right', small:false, title: 'CONTENTS'
            },
            {
                page: 2, dir:'left', small:false,  title: '致辞'
            },
            {
                page: 3, dir:'left', small:false, title: '可持续发展管理／<br>实现无碳化社会的措施'
            },
            {
                page: 3, dir:'right', small:false, title: 'Diversity & Inclusion措施／<br>实现生物多样性的措施'
            },
            {
                page: 4, dir:'left', small:false, title: '三井不动产的城市建设'
            },
            {
                page: 5, dir:'left', small:true, title: '日本桥再开发计划'
            },
            {
                page: 6, dir:'left', small:true, title: '柏叶智能城市'
            },
            {
                page: 7, dir:'left', small:true, title: '城市核心区大型项目'
            },
            {
                page: 8, dir:'left', small:true, title: '全球化措施'
            },
            {
                page: 9, dir:'left', small:false, title: '事业内容'
            },
            {
                page: 10, dir:'left', small:true, title: '办公楼'
            },
            {
                page: 11, dir:'left', small:true, title: '商业设施'
            },
            {
                page: 12, dir:'right', small:true, title: '物流设施'
            },
            {
                page: 13, dir:'left', small:true, title: '酒店、度假设施'
            },
            {
                page: 14, dir:'left', small:true, title: '住房和生活'
            },
            {
                page: 15, dir:'left', small:true, title: '解决方案合作伙伴'
            },
            {
                page: 15, dir:'right', small:true, title: '进军新领域'
            },
            {
                page: 16, dir:'left', small:true, title: '新事业措施'
            },
            {
                page: 16, dir:'right', small:true, title: '致力于数字化转型'
            },
            {
                page: 16, dir:'right', small:true, title: 'S＆E 综合研究所'
            },
            {
                page: 16, dir:'right', small:true, title: 'CARE DESIGN室'
            },
            {
                page: 17, dir:'left', small:false, title: '公司简介／董事／主要国内网点'
            },
            {
                page: 17, dir:'right', small:false, title: '组织结构图'
            },
            {
                page: 18, dir:'left', small:false, title: '主要集团公司的介绍'
            },
            {
                page: 18, dir:'right', small:false, title: '业绩的推移'
            },
            {
                page: 19, dir:'left', small:false, title: '沿革'
            },
        ];
        this.contents = document.querySelector('.js-contents');
        this.contentsInner = document.querySelector('.js-contents-inner');
        this.contentsList = document.querySelector('.js-contents-list');
        this.contentsBG = document.querySelector('.js-contents-bg');
        this.btnClose = document.querySelector('.js-contents-close');
        this.close = this.close.bind(this);


        this.init();
    }

    //初期設定
    init() {
        for(let i=0;i < this.list.length;i++) {
            const o = this.list[i];
            const li = document.createElement('li');
            const button = document.createElement('button');
            li.classList.add('contents__list');
            if(o.small) li.classList.add('contents__list--small');
            button.innerHTML = o.title;
            button.dataset.target = o.page;
            button.dataset.page = o.dir;

            li.appendChild(button);


            this.contentsList.appendChild(li);

            button.addEventListener('click',() => {
                this.pamph.pageDir = button.dataset.page;
                this.pamph.pageJump(Number(button.dataset.target),this.pamph.pageDir);
                if(window.innerWidth <= 768) this.close();

            });
        }
        if(window.innerWidth > 768) {
            this.contents.style.display = 'block';
            gsap.set('.wrapper',{width: 'calc(100% - 300px)'});
            gsap.set(this.contentsBG,{opacity:1});
            gsap.set(this.contentsInner,{x:'0%'});
            gsap.set('.control',{right: 320});
            this.btnClose.addEventListener('click',this.close);
            this.contentsBG.addEventListener('click',this.close);
        }
    }

    open() {
        this.contents.style.display = 'block';
        gsap.fromTo(this.contentsBG,{
            opacity: 0
        },{
            opacity: 1,
            duration: 0.3
        });
        gsap.fromTo(this.contentsInner,{
            x: '100%'
        },{
            x: '0%',
            duration: 0.3
        });
        gsap.to('.wrapper',{
            width: 'calc(100% - 300px)',
            duration: .3
        });
        gsap.to('.control',{
            right: 320,
            duration: 0.3
        })

        this.btnClose.addEventListener('click',this.close);
        this.contentsBG.addEventListener('click',this.close);

    }

    close() {
        this.btnClose.removeEventListener('click',this.close);
        this.contentsBG.removeEventListener('click',this.close);
        gsap.to(this.contentsBG,{
            opacity:0,
            duration: 0.3
        });
        gsap.to(this.contentsInner,{
            x: '100%',
            duration: 0.3,
            onComplete: () => {
                this.contents.style.display = 'none';
            }
        });
        gsap.to('.wrapper',{
            width: '100%',
            duration: .3
        })
        gsap.to('.control',{
            right: 20,
            duration: 0.3
        })

    }
}